import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import set from 'lodash/set'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'
import c from 'classnames'

import * as F from 'discada/dist/Form'
import Loading from 'discada/dist/Loading'
import Icon from 'discada/dist/Icon'

import Config, { ConfigSubmitSet } from 'components/Settings/ConfigForm'
import getSections from 'components/config/quote/sections'
import Collection from 'components/widgets/Collection'

import { hasWrite } from 'selectors/authSelectors'
import { saveConfig, getAllLenders } from 'actions/appStatusActions'

import DefaultSection from 'components/config/quote/DefaultSection'
import { rateMarkets, WHEN_INCLUDE_LABELS } from 'utils'
import { SORT_BYS, MDRIVE_SORT_BYS } from 'selectors/inventorySelectors'

import { getHasMdrive, getHasSqueezeJacket } from 'selectors/appStatusSelectors'

import {
  getConfig,
  getBanks,
  getRooftopInfo,
  getIsGettingConfig,
  getConfigLabel,
  getLibertyMutualLinkEnabled,
} from 'selectors/appStatusSelectors'

import {
  getConfigById,
  getAvailableConfigs,
  clearConfig,
} from 'actions/appStatusActions'

export const WHITE_LIST = [
  'banks',
  'scanOptions',
  'displayOptions',
  'leaseTerms',
  'loanTerms',
  'creditTiers',
  'mileages',
  'downs',
]

export const LEASE_SETTINGS = {
  // TODO reuse on quote
  firstPaymentInCap: {
    label: 'Capitalize First Payment',
    help: 'Increases payment but lowers upfront charges',
  },
  bankFeeUpfront: {
    label: 'Collect Acquisition Fee Upfront',
    help: 'Increases upfront charges but can lower the payment',
  },
  salesTaxInCap: {
    label: 'Capitalize Sales Tax',
    help:
      'May increase payment but can lower upfront charges. Not available in all regions.',
  },
  downpaymentTaxInCap: {
    label: 'Capitalize Cap Cost Reduction Taxes from Cash',
    help:
      'May increase payment but can lower upfront charges. Not available in all regions.',
  },
  cCrRebateTaxInCap: {
    label: 'Capitalize Cap Cost Reduction Taxes from Rebates',
    help: 'May increase payment but can lower upfront charges',
  },
  //cashCanPayTrade: {
  //label: 'Use Customer Cash to pay off Trades First',
  //help: 'Can decrease taxes',
  //},
  //rebateCanPayTrade: {
  //label: 'Use Rebates to pay off Trades First',
  //help: 'Can decrease taxes. Not all rebates can be applied this way.',
  //},
  //tradeInCashBack: {
  //label: 'Return excess Trade Allowance to Customer',
  //help: 'Use allowance to pay upfront charges only, extra cash is not used',
  //},
}

export const DOWN_SETTINGS = {
  treatCashAsCcr: {
    label: 'Use Cash, Rebates and Trade Allowance as CCR [1]',
    help:
      'Applies customer cash directly to Cap Cost. Upfront charges will be collected in addition to any cash from customer.',
    required: ['treatRebateAsCcr', 'treatTradeInAsCcr'],
    disabled: ['cashDoesntCoverInceptionFee'],
  },
  cashDoesntCoverInceptionFee: {
    label: 'Force all upfront charges into the Cap Cost',
    help:
      'All cash will be applied as Cap Cost Reduction. May supersede other lease settings. Requires [1]',
    required: ['treatCashAsCcr', 'treatRebateAsCcr', 'treatTradeInAsCcr'],
  },
  treatRebateAsCcr: {
    label: 'Use Rebates as CCR',
    help: 'Applies all Rebates to the Cap Cost. Included in [1]',
    disabled: ['treatCashAsCcr'],
  },
  treatTradeInAsCcr: {
    label: 'Use Trade Allowance as CCR',
    help:
      'Applies all Trade allowance directly to the Cap Cost. Included in [1]',
    disabled: ['treatCashAsCcr'],
  },
}

/////////////////////////////////

export const DOWN_USAGES = {
  TOTAL_OUT_OF_POCKET: '#1 - Total due at signing, pay inception fees first',
  COLLECT_ALL_INCEPTION_FIRST:
    '#2 - Down Payment (CCR) only, customer also pays inception fees upfront',
  COLLECT_ALL_CCR_ONLY:
    '#3 - Total due at signing, capitalize all inception fees',
}

export function DownPaymentUsage({ value, onChange = () => {} }) {
  return (
    <F.SelectField
      size="small"
      label="Lease Down Payment Means..."
      onChange={({ target }) => onChange(target.value)}
      className="cash-treatment"
      value={value}
    >
      {Object.keys(DOWN_USAGES).map(k => (
        <option key={k} value={k}>
          {DOWN_USAGES[k]}
        </option>
      ))}
    </F.SelectField>
  )
}

export function DealerCashUsage({
  label,
  inline,
  checked,
  onChange = () => {},
}) {
  return (
    <F.CheckboxField
      inline={inline}
      size="small"
      label={label}
      checked={checked}
      onChange={onChange}
      className="dealer-cash-treatment"
    />
  )
}

/////////////////////////////////

export function Bank({ item, editValue, index, bankOptions }) {
  return (
    <div className="quote-config-collection-leaseTerm">
      <F.SelectField
        size="small"
        value={item.bankName}
        onChange={({ target }) => editValue(index, 'bankName', target.value)}
      >
        <option disabled value="">
          Select a Bank
        </option>{' '}
        {bankOptions.map((b, i) => (
          <option key={i} value={b}>
            {b}
          </option>
        ))}
      </F.SelectField>
      <F.CheckboxField
        size="small"
        checked={item.retail}
        onChange={e => editValue(index, 'retail', e.target.checked)}
      />
      <F.CheckboxField
        size="small"
        checked={item.lease}
        onChange={e => editValue(index, 'lease', e.target.checked)}
      />
    </div>
  )
}

export class BankSettings extends Config {
  category = 'program'

  refresh() {
    let { getAvailableConfigs, getConfigById, configId } = this.props

    getAvailableConfigs(this.category).then(
      () => configId && getConfigById(configId),
    )
  }

  componentDidMount() {
    this.refresh(this)
  }

  componentWillUnmount() {
    this.props.clearConfig(this.props.configId)
  }

  toggleCashOptions(key) {
    let option = DOWN_SETTINGS[key],
      { config } = this.state,
      prefix = `scanOptions[0].lease.`,
      currentKey = prefix + key,
      currentValue = get(config, currentKey, false),
      newValue = !currentValue

    if (isEmpty(option)) return

    set(config, currentKey, newValue)

    if (option.required) {
      option.required.forEach(k => set(config, prefix + k, newValue))
    }

    this.setState({ config })
  }

  isOptionDisabled(key) {
    let option = DOWN_SETTINGS[key],
      { config } = this.state,
      prefix = `scanOptions[0].lease.`

    if (isEmpty(option)) return
    if (isEmpty(option.disabled)) return false

    return option.disabled.some(k => get(config, prefix + k, false))
  }

  processConfigForSave() {
    let banks = get(this.state.config, 'banks', []).reduce((ret, b) => {
      let codes = get(
          get(this.state, 'banks', []).find(bb => bb.name === b.bankName),
          'codes',
          {},
        ),
        retailCodes = Object.keys(codes).filter(c => codes[c] === 'retail'),
        leaseCodes = Object.keys(codes).filter(c => codes[c] === 'lease')

      return [
        ...ret,
        {
          ...b,
          codes: [
            ...(b.retail ? retailCodes : []),
            ...(b.lease ? leaseCodes : []),
          ],
        },
      ]
    }, [])

    let config = {
        ...this.state.config,
        banks,
      },
      ret = WHITE_LIST.reduce((ret, k) => ({ ...ret, [k]: config[k] }), {})

    return ret
  }

  render() {
    let {
        canDo,
        banks,
        rooftopZip,
        isLoading,
        label,
        onClose,
        saveConfig,
        configId,
        usingMdrive,
        squeezeJacketAvailable,
      } = this.props,
      sections = getSections({
        editValue: this.editValue,
      }),
      { config } = this.state,
      bankOptions = (banks || []).map(b => b.name),
      items = get(this.state.config, 'banks', [])

    if (!canDo) return null
    if (isLoading) return <Loading />

    return (
      <div className="bank-settings">
        <h1>
          <Icon icon="university" /> <strong>Quotes</strong>,{' '}
          <strong>Banks</strong>, and <strong>Taxes</strong>
          <small>{label}</small>
        </h1>
        <section className="quote-banks">
          <h3>Defaults</h3>
          <article className="message is-info is-small">
            <div className="message-body">
              These defaults will be used to generate starting quote information
              as well as alternate quote options. The starting values you select
              here will be used to display default payments on vehicle listing
              and detail pages.
              <br />
              <br />
              <strong>Please note</strong> that it may take several hours for
              your inventory to reflect any changes you make here
            </div>
          </article>
          {Object.keys(sections).map(s => (
            <DefaultSection
              {...sections[s]}
              key={s}
              valueKey={s}
              label={sections[s].valueSelectorLabel}
              collectionHeaders={sections[s].headers}
              values={get(config, s, [])}
              selected={get(get(config, s, []).find(v => v.default), 'value')}
              addItem={this.addItem(s, sections[s].starter)}
              removeItem={this.removeItem(s, true)}
              itemRenderer={sections[s].renderer(s)}
              onChange={this.makeDefault(s)}
              children={sections[s].children}
              configType={sections[s].configType}
              withConfig
            />
          ))}
          <hr />
          <F.SelectField
            size="small"
            label="Default All Cars Sort"
            help="This is the default sort option for the All Cars page"
            value={get(config, 'displayOptions.defaultSort', -1)}
            options={usingMdrive ? MDRIVE_SORT_BYS : SORT_BYS}
            onChange={({ target }) =>
              this.editValue('displayOptions')(
                null,
                'defaultSort',
                target.value,
              )
            }
          />
        </section>
        {!usingMdrive && (
          <section>
            <h3>Banks</h3>
            <article className="message is-info is-small">
              <div className="message-body">
                Select the banks you want to do business with. Programs from
                these banks will be used to generate payments.
              </div>
            </article>
            {['banks'].map(s => (
              <Collection
                key={s}
                headers={['Bank', 'Use for Loans', 'Use for Leases']}
                className={c(
                  'quote-config-collection',
                  `quote-config-collection-${s}`,
                )}
                items={items}
                addItem={this.addItem(s, {
                  bankName: '',
                  retail: true,
                  lease: true,
                })}
                removeItem={this.removeItem(s)}
                itemRenderer={(item, index, items) => (
                  <Bank
                    {...{ item, index, items }}
                    editValue={this.editValue(s)}
                    bankOptions={bankOptions}
                  />
                )}
              />
            ))}
          </section>
        )}
        <section>
          <h3>Taxes and Regional Settings</h3>
          {!usingMdrive && (
            <div className="config-row">
              <F.TextField
                size="small"
                type="string"
                label="Default Customer Zip Code"
                help={`Used for finding rebates and calculating taxes, leave blank to use ${rooftopZip}`}
                value={get(config, 'scanOptions[0].customerZipCode')}
                onChange={({ target }) =>
                  this.editValue('scanOptions')(
                    0,
                    'customerZipCode',
                    target.value,
                  )
                }
              />

              <F.SelectField
                size="small"
                label="Default Rate Region"
                help="This is the region that we will default to when showing programs"
                value={get(config, 'scanOptions[0].rateMarket', -1)}
                options={{ [-1]: 'Auto', ...rateMarkets }}
                onChange={({ target }) =>
                  this.editValue('scanOptions')(0, 'rateMarket', target.value)
                }
              />
            </div>
          )}
          <div className="config-row">
            <F.SelectField
              size="small"
              label="When should we include taxes?"
              value={get(config, 'scanOptions[0].includeTaxes')}
              options={WHEN_INCLUDE_LABELS}
              help="Taxes can still be manually toggled for custom quotes"
              onChange={({ target }) =>
                this.editValue('scanOptions')(0, 'includeTaxes', target.value)
              }
            />
            <F.SelectField
              size="small"
              label="When should we include fees?"
              value={get(config, 'scanOptions[0].includeFees')}
              options={WHEN_INCLUDE_LABELS}
              help="Fees can still be manually toggled for custom quotes"
              onChange={({ target }) =>
                this.editValue('scanOptions')(0, 'includeFees', target.value)
              }
            />
          </div>
          {!usingMdrive && (
            <div className="config-row">
              <F.TextField
                size="small"
                type="string"
                label="Texas VIT Tax Rate"
                help={`Used to apply VIT tax rate to quotes for dealers in Texas. Leave blank if this does not apply to your rooftop.`}
                validateFor="decimal"
                value={get(config, 'scanOptions[0].texasVitTaxRate', '')}
                onChange={({ target }) =>
                  this.editValue('scanOptions')(
                    0,
                    'texasVitTaxRate',
                    target.value,
                  )
                }
              />
              <div>{/* just forcing the field above  to be 50% width*/}</div>
            </div>
          )}
        </section>
        <section>
          <h3>Payment Range Settings</h3>
          <div className="config-row">
            <F.TextField
              size="small"
              type="number"
              label="Payment Range Percent"
              iconRight="percent"
              help="We will take the starting payment and bump it by this much to create a range"
              value={get(config, 'scanOptions[0].paymentRangePercent')}
              onChange={({ target }) =>
                this.editValue('scanOptions')(
                  0,
                  'paymentRangePercent',
                  target.value,
                )
              }
            />
            <F.SelectField
              size="small"
              type="number"
              label="Nearest Payment Round"
              iconRight="percent"
              options={{
                1: '$1',
                5: '$5',
                10: '$10',
                15: '$15',
                20: '$20',
                25: '$25',
                50: '$50',
                0: "Don't Round",
              }}
              help="We will take the starting payment and round it to the nearest matching multiple of this value"
              value={get(config, 'scanOptions[0].paymentRoundTo')}
              onChange={({ target }) =>
                this.editValue('scanOptions')(0, 'paymentRoundTo', target.value)
              }
            />
          </div>
          <div className="config-row">
            <F.CheckboxField
              label="Hide Cash Price from unknown customers"
              checked={get(config, 'scanOptions[0].hidePriceForUnknown', false)}
              help="If your ad convenants prevent you from showing Price to customers until you are 1-to-1 with them, check this box to hide the price. Customers w
            ill still be shown loan and lease payments where applicable"
              onChange={() =>
                this.editValue('scanOptions')(
                  0,
                  'hidePriceForUnknown',
                  !get(config, 'scanOptions[0].hidePriceForUnknown'),
                )
              }
            />
          </div>
          <div className="config-row">
            <F.TextField
              size="small"
              type="number"
              label={
                <span>
                  <span role="img" aria-label="squeeze">
                    🍋
                  </span>
                  Squeeze Anonymous Visitors
                </span>
              }
              help="Enter the number of clicks an anonymous visitor can make before being presented with a lead form"
              value={get(config, 'scanOptions[0].squeezeLimit')}
              onChange={({ target }) =>
                this.editValue('scanOptions')(0, 'squeezeLimit', target.value)
              }
            />
            {squeezeJacketAvailable && (
              <F.CheckboxField
                label="Enable Squeeze Jacket"
                checked={get(
                  config,
                  'scanOptions[0].enableSqueezeJacket',
                  false,
                )}
                xchecked={(() => {
                  let scanOptions = get(config, 'scanOptions[0]'),
                    k = 'enableSqueezeJacket'

                  return (
                    !scanOptions.hasOwnProperty(k) || get(scanOptions, k, false)
                  )
                })()}
                help="Enables Squeeze Jacket functionality to progressively gather information about your visitors"
                onChange={() =>
                  this.editValue('scanOptions')(
                    0,
                    'enableSqueezeJacket',
                    !get(config, 'scanOptions[0].enableSqueezeJacket', true),
                  )
                }
              />
            )}
            {usingMdrive && (
              <F.TextField
                size="small"
                type="number"
                label="Payment Search Wiggle Percent"
                iconRight="percent"
                help="When a customer searches for a payment, we will show payments +/- this percentage"
                value={get(config, 'scanOptions[0].paymentSearchWiggle', 3)}
                onChange={({ target }) =>
                  this.editValue('scanOptions')(
                    0,
                    'paymentSearchWiggle',
                    target.value,
                  )
                }
              />
            )}
          </div>
        </section>
        {!usingMdrive && (
          <section>
            <h3>Lease Structure Settings</h3>
            {false && (
              <div className="config-row">
                <DownPaymentUsage
                  value={get(
                    this.state.config,
                    'scanOptions[0].downPaymentUsage',
                  )}
                  onChange={downPaymentUsage =>
                    this.editValue('scanOptions')(
                      0,
                      'downPaymentUsage',
                      downPaymentUsage,
                    )
                  }
                />
              </div>
            )}
            <div className="config-row">
              {Object.keys(LEASE_SETTINGS).map(k => (
                <F.Switch
                  size="small"
                  className="lease-switch"
                  key={k}
                  rounded
                  label={<strong>{LEASE_SETTINGS[k].label}</strong>}
                  help={LEASE_SETTINGS[k].help}
                  value={get(config, `scanOptions[0].lease.${k}`, false)}
                  onChange={() =>
                    this.editValue('scanOptions')(
                      0,
                      `lease.${k}`,
                      !get(config, `scanOptions[0].lease.${k}`),
                    )
                  }
                />
              ))}
            </div>
            <hr />
            <div className="config-row">
              {Object.keys(DOWN_SETTINGS).map(k => (
                <F.Switch
                  size="small"
                  className="lease-switch"
                  key={k}
                  rounded
                  label={<strong>{DOWN_SETTINGS[k].label}</strong>}
                  help={DOWN_SETTINGS[k].help}
                  value={get(config, `scanOptions[0].lease.${k}`, false)}
                  onChange={() => this.toggleCashOptions(k)}
                  disabled={this.isOptionDisabled(k)}
                />
              ))}
            </div>
          </section>
        )}

        <section>
          <h3>Other Settings</h3>
          {!usingMdrive && (
            <div className="config-row">
              <DealerCashUsage
                label="Use Dealer Cash to Reduce Price"
                checked={get(
                  this.state.config,
                  'scanOptions[0].dealerIncentivesReducePrice',
                  false,
                )}
                onChange={() =>
                  this.editValue('scanOptions')(
                    0,
                    'dealerIncentivesReducePrice',
                    !get(
                      this.state.config,
                      'scanOptions[0].dealerIncentivesReducePrice',
                    ),
                  )
                }
              />
              <DealerCashUsage
                label="Use Paid Reserve to Reduce Price"
                checked={get(
                  this.state.config,
                  'scanOptions[0].paidReserveReducesPrice',
                  false,
                )}
                onChange={() =>
                  this.editValue('scanOptions')(
                    0,
                    'paidReserveReducesPrice',
                    !get(
                      this.state.config,
                      'scanOptions[0].paidReserveReducesPrice',
                    ),
                  )
                }
              />
            </div>
          )}
          <div className="config-row">
            <F.TextField
              size="small"
              label="Phone Number (Numbers only)"
              help="Enter your sales line or call tracking number you wish to use for Illumiquote"
              value={get(config, 'displayOptions.salesPhone', '')}
              validateFor="phone"
              onChange={({ target }) =>
                this.editValue('displayOptions')(
                  null,
                  'salesPhone',
                  target.value,
                )
              }
            />
          </div>
          <div className="config-row">
            <F.TextField
              size="small"
              label="Link to Online Credit Application"
              help="If present, we'll show the link to customers so they can fill it out"
              value={get(config, 'displayOptions.creditAppLink', '')}
              onChange={({ target }) =>
                this.editValue('displayOptions')(
                  null,
                  'creditAppLink',
                  target.value,
                )
              }
            />
            <F.TextField
              size="small"
              label="Link to Accessories"
              help="If present, we'll show the link to customers when they save a quote"
              value={get(config, 'displayOptions.accessoriesLink', '')}
              onChange={({ target }) =>
                this.editValue('displayOptions')(
                  null,
                  'accessoriesLink',
                  target.value,
                )
              }
            />
          </div>
          <div className="config-row">
            <F.TextField
              size="small"
              label="Link to Digital Retailing Tool"
              help="If present, we'll show the link to customers so they can use your DR tool"
              value={get(config, 'displayOptions.drLink', '')}
              onChange={({ target }) =>
                this.editValue('displayOptions')(null, 'drLink', target.value)
              }
            />
          </div>
          <div className="config-row">
            {!usingMdrive && (
              <F.CheckboxField
                label="Show Leases on Used Cars"
                checked={get(config, 'scanOptions[0].includeUsedCarLeases')}
                onChange={() =>
                  this.editValue('scanOptions')(
                    0,
                    'includeUsedCarLeases',
                    !get(config, 'scanOptions[0].includeUsedCarLeases'),
                  )
                }
              />
            )}
            <F.CheckboxField
              label="Show 'At Home' delivery and test drive options"
              checked={get(config, 'displayOptions.homeDelivery')}
              onChange={() =>
                this.editValue('displayOptions')(
                  null,
                  'homeDelivery',
                  !get(config, 'displayOptions.homeDelivery'),
                )
              }
            />
          </div>
        </section>
        <ConfigSubmitSet
          onSubmit={() =>
            saveConfig(
              this.category,
              this.processConfigForSave(WHITE_LIST),
              configId,
              onClose,
              error => this.setState({ error }),
            )
          }
          errorMessage={this.state.error}
          onCancel={onClose}
        />
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let { id } = op,
    config = getConfig(state, id)

  return {
    ...op,
    configId: id,
    config,
    label: getConfigLabel(state, id),
    canDo: hasWrite(state, 'rooftop.config/quote'),
    banks: getBanks(state),
    rooftopZip: get(getRooftopInfo(state), 'address.postalCode'),
    isLoading: getIsGettingConfig(state) || isNull(config),
    usingMdrive: getHasMdrive(state),
    squeezeJacketAvailable: getHasSqueezeJacket(state),
    libertyMutualLinkEnabled: getLibertyMutualLinkEnabled(state),
  }
}

export default connect(
  mapStateToProps,
  {
    saveConfig,
    getAllLenders,
    getAvailableConfigs,
    getConfigById,
    clearConfig,
  },
)(BankSettings)
